import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Add .js to the end of these three lines
import AuthPage from './pages/authpage.js';
import Dashboard from './pages/dashboard.js';
import TicketDetail from './pages/ticketdetail.js';
import Toast from './components/toast.js';

import './styles/App.css';

export default function App() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const showToast = (message, type) => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 3000);
  };

  return (
    <Router>
      <Toast toast={toast} />
      <Routes>
        <Route path="/" element={!user ? <AuthPage setUser={setUser} showToast={showToast} /> : <Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={user ? <Dashboard user={user} setUser={setUser} showToast={showToast} /> : <Navigate to="/" />} />
        <Route path="/ticket/:id" element={<TicketDetail />} />
      </Routes>
    </Router>
  );
}

